import type { AcademyTrainingsFixedFilters } from '~/composables/useAcademyTrainingsListing';
import type { AcademyTrainingsCarouselStoryblok } from '~storyblok-types/AcademyTrainingsCarouselStoryblok';
import { OPEN_STATES, IN_PROGRESS_STATE } from '~/utils/academy/constants';

/**
 * Maps the carousel blok type to fixed listing query filters.
 */
export function buildCarouselFixedFilters(
    type: AcademyTrainingsCarouselStoryblok['type']
): AcademyTrainingsFixedFilters {
    switch (type) {
        case 'course':
            return {
                type: 'course',
                status: OPEN_STATES.join(',')
            };
        case 'event':
            return { type: 'event' };
        case 'course-started': {
            return {
                type: 'course',
                status: IN_PROGRESS_STATE
            };
        }
        case 'related-courses':
            return {};
        default: {
            const unhandledType: never = type;

            log.warn(`[buildCarouselFixedFilters] unhandled type: ${unhandledType}`);
            return {};
        }
    }
}
